import {DictType} from "./dictType.model";
import {
  DossierBool, DossierDate,
  DossierM50, DossierN17,
  DossierN3,
  DossierN5, DossierN9,
  DossierT100,
  DossierT2000,
  DossierT250, DossierT36,
  DossierT4000
} from "./base.model";
import {NetworkInfo} from "./networkInfo.model";

export class DopInfoType {
  divisions?: DivisionInfo[] = undefined
  selfEmployed?: DossierBool = false;
  category?: DictType = undefined;
  sho?: DossierBool = '';
  goz?: DossierBool = false;
  orc?: DossierBool = false;
  leastCapital?: DossierM50 = '';
  currencyReg?: DictType = undefined;
  capital?: DossierM50 = '';
  currencyPaid?: DictType = undefined;
  share: DossierN3 = '';
  asset: DossierT2000 = '';
  estate?: DictType[] = undefined;
  otherSource?: DossierT4000 = '';
  staffCount?: DossierN5 = '';
  wageFund?: DossierM50 = '';
  accountsDep?: DictType = undefined;
  activity?: DictType = undefined;
  income?: DictType = undefined;
  reputation?: DictType = undefined;
  network: Array<NetworkInfo> = undefined;
  dmdk?: DossierBool = false;
  dmdkInfo?: DmdkInfo;
  nko?: DossierBool = false;
}

export class DivisionInfo {
  divname?: DossierT100 = undefined;
  divKPP?: DossierN9 = undefined;
  divaddress?: DossierT250 = undefined;
  row: number;
}

export class DmdkInfo {
  iddoc?: DossierT36 = undefined;
  numberdoc?: DossierN17 = undefined;
  datedoc?: DossierDate = undefined;
  startDate?: DossierDate = undefined;
  userName?: DossierT250 = undefined;
}